<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content bg-purple" style="opacity:0">1</div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple" style="margin-bottom:20px">无用户权限!</div>
        <el-button type="primary" @click="go_xianxiao">返回先晓</el-button>
        <el-button type="primary" @click="go_meet">返回会议平台</el-button>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple" style="opacity:0">2</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple" style="opacity:0">3</div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xianxiao_url: "",
      conference_url: "",
    };
  },
  created() {
    this.xianxiao_url = this.$cookies.get("xianxiao_url");
    this.conference_url = this.$cookies.get("conference_url");
  },
  methods: {
    go_xianxiao() {
      var _this = this;
      window.location.href = "/";
    },
    go_meet() {
      var _this = this;
      window.location.href = _this.conference_url;
    },
  },
};
</script>
<style  scoped>
div {
  text-align: center;
  font-size: 30px;
  margin-top: 40px;
}
</style>